import React, {useReducer } from "react";
import AppErrorBoundary from "./Refactor/components/ErrorBoundary";
import {
  Footer,
  FrameBody,
  SubHeader,
  Wait,
  FrameTop,
} from "@npd-ng/adp-benchmark";
import { initialState, reducer } from "./Refactor/state";
import ModeSelectionView from "./Refactor/views/ModeSelectionView";
import AppHeader from "./Refactor/components/AppHeader";
import { useInitilizeService } from "./Refactor/hooks/useInitilizeService";
import ErrorView from "./Refactor/views/ErrorView";
import DeviceReadinessView from "./Refactor/views/DeviceReadinessView";
import UpdaterView from "./Refactor/views/UpdaterView";
import SetupCodeValidationView from "./Refactor/views/SetupCodeValidationView";
import WarningView from "./Refactor/views/WarningView";
import WaitView from "./Refactor/views/WaitView";
import RedirectionView from "./Refactor/views/RedirectionView";
import ErrorLoadinfView from "./Refactor/views/ErrorLoadingView";
import { useAppState } from "./Refactor/hooks/useAppState";

function App() {
  const { state, dispatch } = useAppState();
  useInitilizeService(dispatch, state);
  const getCurrentView = () => {
    switch (state.appState.currentView) {
      case "ModeSelectionsView":
        return <ModeSelectionView/>;
      case "WaitView":
        return <WaitView/>;
      case "ErrorView":
        return <ErrorView/>;
      case "WarningView":
        return <WarningView />;
      case "DeviceValidationView":
        return <DeviceReadinessView />;
      case "UpdaterView":
        return <UpdaterView />;
      case "SetupCodeValidationView":
        return <SetupCodeValidationView />;
      case "RedirectionView":
        return <RedirectionView />;
    }
  };
  return (
    <AppErrorBoundary hasError={false}>
      {state.appState.currentView !== "LoadingView" && state.appState.currentView!=="LoadingErrroView" && (
        <>
          <AppHeader
            dispatch={dispatch}
            state={state}
          />
          <SubHeader
            releaseVersion={{
              title: state.staticContent?.versionLabel as string,
              version: state.appState.releaseVersion as string,
              versionColors: state.appState.configuration?.versionColors as [],
              versionBorderColors: state.appState.configuration
                ?.versionBorderColors as [],
            }}
            deviceInfo={{
              deviceLabel: state.staticContent?.deviceLabel as string,
              deviceId: state.deviceState.deviceId as string,
              deviceType: state.staticContent?.title as string,
            }}
          />
          {getCurrentView()}
        </>
      )}
      {state.appState.currentView === "LoadingView" && (
        <>
          <FrameTop>
            <span></span>
          </FrameTop>
          <FrameBody>
            <Wait subTitle={"loading..."} />
          </FrameBody>
        </>
      )}
      {state.appState.currentView === "LoadingErrroView" && (
        <>
          <ErrorLoadinfView />
        </>
      )}
      <Footer primary={true} />
    </AppErrorBoundary>
  );
}

export default App;
